import { useCallback } from 'react';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { useScrollToItem } from 'common/condensedMenu/scrollToItem';

type LinkActionResult = {
  asLink: boolean;
  href: string | undefined;
  linkOnClick: (() => void) | undefined;
};

export const useLinkAction = (link?: LinkField, onClickOverride?: () => void): LinkActionResult => {
  const { scrollTo } = useScrollToItem();
  const { anchor, href, linktype } = link?.value || {};

  const handleAnchorClick = useCallback(() => {
    if (!anchor) return;
    void scrollTo(anchor, 'smooth').then(() => {
      // Move focus into the section so Tab continues from here, not the link.
      document.getElementById(anchor)?.focus({ preventScroll: true });
    });
  }, [anchor, scrollTo]);

  const isAnchorLink = !!anchor && (linktype === 'anchor' || !href);
  const isHrefLink = !onClickOverride && !isAnchorLink && !!href;

  return {
    asLink: isHrefLink,
    href: isHrefLink ? href : undefined,
    linkOnClick: onClickOverride ?? (isAnchorLink ? handleAnchorClick : undefined),
  };
};
